import { Navigate, useLocation } from 'react-router-dom'
import { getDisabledLearnerRouteFallbackPath } from './learner-feature-availability'
import { learnerPaths } from './route-paths'

const shortVideosFallbackPath =
  getDisabledLearnerRouteFallbackPath('short-videos') ?? learnerPaths.shortVideos

const legacyScreenRedirects: Record<string, string> = {
  '0': learnerPaths.learning,
  '1': learnerPaths.profile,
  '2': learnerPaths.settings,
  '3': learnerPaths.flashcards,
  '4': shortVideosFallbackPath,
  '5': learnerPaths.teachers,
  '6': learnerPaths.premium,
  '7': learnerPaths.learningListeningQuiz,
  '8': learnerPaths.learningEbooks,
  '9': learnerPaths.learningEbooks,
  '10': learnerPaths.learningAudio,
  default: learnerPaths.learning,
}

function getLegacyDashboardRedirectTarget(search: string) {
  const searchParams = new URLSearchParams(search)
  const rawScreen =
    searchParams.get('screen') ??
    searchParams.get('legacyScreen') ??
    searchParams.get('legacyScreenId') ??
    'default'

  return legacyScreenRedirects[rawScreen] ?? learnerPaths.learning
}

export function LegacyDashboardRedirect() {
  const location = useLocation()

  return (
    <Navigate
      replace
      state={location.state}
      to={getLegacyDashboardRedirectTarget(location.search)}
    />
  )
}
